import {
    getCurrentBusDateOrCurrentDate
} from "utils/FormatUtils"
import {createContext, useEffect, useState, useContext} from "react";
import {dateToString, getCurrentDate} from "utils/FormatUtils"
import {SecurityContext} from "../../../../context/security";
import {EntityAccountsContext} from "../../../../components/entity-accounts/context";
import {SWIFT_MESSAGE_URL_SEARCH} from "../../../../service/UrlConstant"
import {ToastContext} from "../../../../context/Toast";
import {
    SWIFT_MESSAGE_SEARCH
} from "../../../../routes/Routes";
import {useLocation} from "react-router";
import {normaliseFilterValueAllToEmptyString} from "../../../../utils/StringUtils";

const searchDate = getCurrentBusDateOrCurrentDate();


const initialState={
    'search':{
        'direction':'ALL',
        'processed':'ALL',
        'messageType':'ALL',
        'date': searchDate,

    },
    'currentPage': 'defaultlanding'
}
const errorInitState = {'search': {}}

export const Context = createContext({});

export const Provider = props => {

    const {children} = props;
    const [swiftMessageSearchDisplayState, setSwiftMessageSearchDisplayState] = useState(null);
    const [swiftMessageState, setSwiftMessageState] = useState(JSON.parse(JSON.stringify(initialState)));
    const [panelDisplayState,setPanelDisplayState] = useState(JSON.parse(JSON.stringify(initialState)));
    const [showSearch, setShowSearch] = useState(true);
    const [currentSwiftLayout, setCurrentSwiftLayout] = useState(null)
    const location = useLocation();
    const [loadTrigger, setLoadTrigger] = useState(false)
    const [navPathHistory, setNavPathHistory] = useState([])
    const [showBadge, setShowBadge] = useState(false);
    const {makePostRequest} = useContext(SecurityContext)
    const {paramBadgeInfo} = useContext(EntityAccountsContext)
    const {error} = useContext(ToastContext);



    useEffect(()=>{
        setNavPathHistory((prevHistory)=> [...prevHistory, location.pathname])

        const currentPath = location.pathname;
        const previousPath = navPathHistory[navPathHistory.length - 1]  || '';
        const shouldLoad = (currentPath === SWIFT_MESSAGE_SEARCH)
        setLoadTrigger(shouldLoad)

    },[location])

    const getErrorInitState = () => {
        return JSON.parse(JSON.stringify(errorInitState));
    }
    const clearSwiftMessageState = () =>{
        setSwiftMessageState({...JSON.parse(JSON.stringify(initialState))});
    }

    const clearSwiftMessageSearchDisplayState = () =>{
        setSwiftMessageSearchDisplayState(null);
    }

    const handlePageRequest =(pageName)=>{
        const newFilterState = {...panelDisplayState}
        newFilterState['currentPage'] = pageName;
        setPanelDisplayState(newFilterState);
    }

    const setSwiftToolBarRefreshCriteria = (response, entityAccountsNoSwap)=>{

        const shortSwiftMessageSearchDisplayDetails = {
            resData : response.data,
            searchCriteria : {
                "managerId": entityAccountsNoSwap.managerId,
                'direction':'',
                'processed':'',
                'messageType':'',
                "date": getCurrentDate()
            }
        }
        setSwiftMessageSearchDisplayState({...shortSwiftMessageSearchDisplayDetails});
    }

    const loadSwiftMessages = (entity) => {
        const entityManagerId = String(entity.managerId);
        const searchCriteria =  {
            'indDirection':normaliseFilterValueAllToEmptyString(swiftMessageState.search.direction),
            'indProcessCltTrade':normaliseFilterValueAllToEmptyString(swiftMessageState.search.processed),
            'cdMtMsgType':normaliseFilterValueAllToEmptyString(swiftMessageState.search.messageType),
            "effectiveDate": dateToString(swiftMessageState.search.date),
        }

        const onSuccess = (response) => {
            if(!response.data || response.data.length === 0){
                const searchDisplay = {
                    searchCriteria : searchCriteria
                }
                setSwiftMessageSearchDisplayState(searchDisplay);
            }
            else {
                const shortSwiftMessageDisplayDetails = {
                    resData : response.data,
                    searchCriteria : searchCriteria
                }
                setSwiftMessageSearchDisplayState(shortSwiftMessageDisplayDetails);
                swiftMessageState['currentPage'] = 'search';
                setPanelDisplayState({...swiftMessageState});
            }
        }
        const onError = (err) => {
            console.error(err);
            //error('Error loading swift messages list');
        }
        makePostRequest(searchCriteria, SWIFT_MESSAGE_URL_SEARCH, onSuccess, onError);

    };


    const swiftMessageContext = {
        swiftMessageSearchDisplayState,
        setSwiftMessageSearchDisplayState,
        swiftMessageState,
        setSwiftMessageState,
        clearSwiftMessageState,
        initialState,
        handlePageRequest,
        panelDisplayState,
        setPanelDisplayState,
        getErrorInitState,
        showSearch,
        setShowSearch,
        currentSwiftLayout,
        setCurrentSwiftLayout,
        loadTrigger,
        setLoadTrigger,
        setSwiftToolBarRefreshCriteria,
        clearSwiftMessageSearchDisplayState,
        loadSwiftMessages,
        setShowBadge,
        showBadge
    }

    return <Context.Provider value={swiftMessageContext}>{children}</Context.Provider>

};

export const {Consumer} = Context;
